import React, { useState, useEffect } from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import SubNavigator from '../../components/SubNavigator';
import { useLocation,useNavigate } from 'react-router-dom';

const staticLinks = [
  // 게시판 관리는 마지막에 추가되도록 변경
];



export default function Community() {
  const location = useLocation();
  const navigate = useNavigate();
  const [links, setLinks] = useState([]);
  
  console.log('PC Community 컴포넌트 렌더링됨 - 화면 너비:', window.innerWidth);

  useEffect(() => {
    // API 호출하여 테이블 이름 가져오기
    const fetchBoardTables = async () => {
      try {
        console.log('PC Community - API 시작');
        const response = await fetch('/request/getBoardTables?category=Community',{credentials:'include'}); // 실제 API 엔드포인트로 변경
        console.log('PC Community - Response status:', response.status);
        
        const data = await response.json();
        console.log('PC Community - API 데이터:', data);

        // 가져온 테이블 이름을 링크로 변환
        const dynamicLinks = data.map(table => ({
          path: `/Community/Board/${table.boardId}`,
          label: table.boardTitle // ants_ 및 _board 제거하여 보기 좋게 만듦
        }));

        // 동적 링크 먼저, 그 다음 게시판 관리 추가
        const adminLink = { path: '/Community/BoardAdmin', label: '게시판 관리' };
        console.log('PC Community - 최종 링크:', [...dynamicLinks, adminLink]);
        setLinks([...dynamicLinks, adminLink]);
      } catch (error) {
        console.error('PC Community - Error fetching board tables:', error);
      }
    };

    fetchBoardTables();
  }, []);
  useEffect(()=>{
    if (links.length > 0 ) {
      if(location?.state?.fromNavigator===true){
        navigate(links[0].path);
      }
    }
  },[location,links])
  return (
    <div className="Community" style={{ display: 'flex', width: '100%', height: '100%'}}>
      <nav style={{ display: 'flex', flexDirection: 'row', backgroundColor: 'gray' }}>
        <SubNavigator links={links} />
      </nav>
      <main style={{ display: 'flex', width: '100%', background: '#fff' }}>
        <Outlet />
      </main>
    </div>
  );
}